
    import Loader from "../components/Loaders/Loader.vue";
    import { mapState } from 'vuex';

    export default {
        name: "cart",
        head(){
            return{
                title: 'Dental Web Shop | Korpa',
                meta: [
                    {
                        hid: 'og-title',
                        property: 'og:title',
                        content: 'Dental Web Shop || Korpa',
                    },
                    {
                        hid: 'og-url',
                        property: 'og:url',
                        content: 'https://shop.dentalgrupabih.ba/cart',
                    },
                    {
                        hid: 'og-image',
                        property: 'og:image',
                        content: 'https://shop.dentalgrupabih.ba/logo.png'
                    },
                    {
                        hid: 'og-type',
                        property: 'og:type',
                        content: 'website',
                    }
                ]
            }
        },
        data: function () {
            return {
                //cart_items: [],
                loading: false,
                selected_cart_item: null,
                delete_modal_visible: false,
            };
        },
        computed: mapState({
            cart_items: state => state.items,
        }),
        beforeCreate() {
            //console.log('setup');
        },
        created() {},
        beforeMount() {
            //console.log('mounting');
        },
        mounted() {
        },
        methods: {

            get_product_image(cart_item){

                if(cart_item.product.featured_image){
                    return "url(\"" + cart_item.product.featured_image + "\")";
                } else {
                    return "url(\"" + require('~/assets/placeholders/missing_image.png') + "\")";
                }

                // if(cart_item.product.images){
                //     if(cart_item.product.images.length > 0){
                //         return "url(\"" + this.$axios.defaults.baseURL + `image?imagePath=${cart_item.product.images[0].image}` + "\")";
                //     }
                //     return "url(\"" + require('~/assets/placeholders/missing_image.png') + "\")";
                // } else {
                //     return "url(\"" + require('~/assets/placeholders/missing_image.png') + "\")";
                // }
            },


            deleteCartItem() {
                this.$store.dispatch('removeProductFromCart', this.selected_cart_item);
                this.dismiss();
            },

            

            toggleDeleteItem(cart_item){
                if(!this.delete_modal_visible){
                    this.selected_cart_item = cart_item;
                } else {
                    this.selected_cart_item = null;
                }
                this.delete_modal_visible = !this.delete_modal_visible;
            },



            dismiss(){
                this.selected_cart_item = null;
                this.delete_modal_visible = false;
            },
            


            item_total_price(cart_item){
                return cart_item.product.price * cart_item.quantity;
            },



            get_total(){
                var price = 0;
                this.cart_items.forEach(item => {
                    price += item.product.price * item.quantity;
                })
                return price;
            },



            // decreaseQuantity(cart_item){
            //     if(cart_item.quantity > 1){
            //         this.$store.dispatch('decreaseQuantity', cart_item.product);
            //     }
            // },



            // increaseQuantity(cart_item){
            //     this.$store.dispatch('increaseQuantity', cart_item.product);
            // }
        },
        components: { Loader }
    }
